import { useEffect } from "react";

/**
 * Marks the document as the signed-in/auth surface so app.css tokens apply,
 * including to Radix portals rendered on document.body.
 * Marketing routes must never call this.
 *
 * The PWA theme-color meta tag is left unchanged. That global colour is not
 * approved yet; public pages keep the existing purple theme-color.
 */
export function useAppSurface() {
  useEffect(() => {
    const root = document.documentElement;
    const previous = root.dataset.surface;
    root.dataset.surface = "app";
    return () => {
      if (previous) root.dataset.surface = previous;
      else delete root.dataset.surface;
    };
  }, []);
}
